export default "__VITE_ASSET__c9f2b2f9__"